export enum DiemakerRuleMainType {
    Flat = 'flat',
    Rotary = 'rotary'
}
